import styled, { keyframes } from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

export const LoadingContainer = styled.div`
  text-align: center;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); 
  }
  100% { transform: rotate(360deg); 
  }
`;

export const Spinner = styled.i.attrs({
  "aria-hidden": true,
  className: "fa fa-circle-o-notch"
})`
  animation: ${spin} 1s infinite linear;
  color: ${colors.primary};
  font-size: 28px;
  margin-bottom: 15px;
`;
